import { PasskeysImage } from '@capsicum/common';
import { Button, ButtonSection, Image } from '@capsicum/common-web';
import { useNCRegistration } from '@capsicum/features/nc-onboarding/shared';
import React from 'react';
import styled from 'styled-components';

type NCRegistrationStartProps = {
	isContinueButtonDisabled: boolean;
	isContinueButtonLoading: boolean;
	onClickContinue: () => void;
};

export const NCRegistrationStart: React.FC<NCRegistrationStartProps> = ({
	isContinueButtonDisabled,
	isContinueButtonLoading,
	onClickContinue
}: NCRegistrationStartProps) => {
	const { texts: intlTexts } = useNCRegistration();

	return (
		<S.Container>
			<S.Title>{intlTexts.title}</S.Title>
			<S.InfoText>{intlTexts.mainText}</S.InfoText>
			<S.ImageContainer>
				<S.StyledImage alt="Passkeys" src={PasskeysImage} />
			</S.ImageContainer>
			<ButtonSection>
				<Button
					color="brand"
					disabled={isContinueButtonDisabled || isContinueButtonLoading}
					fullWidth
					isLoading={isContinueButtonLoading}
					testID="ncWallet-registrate-button"
					text={intlTexts.buttonContinue}
					variant="default"
					onClick={onClickContinue}
				/>
			</ButtonSection>
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		width: 100%;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		flex-flow: column;
		padding: ${({ theme }) => theme.spacings.xsmall};
		gap: ${({ theme }) => theme.spacings.xxlarge};
		margin-top: ${({ theme }) => theme.spacings.xlarge};
	`;

	export const Title = styled.div`
		${({ theme }) => theme.fonts.headings.title5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const InfoText = styled.div`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.subtle};
		margin-bottom: ${({ theme }) => theme.spacings.large};
	`;

	export const StyledImage = styled(Image)`
		top: 0;
		left: 0;
		width: 100%;
		object-fit: contain;
	`;

	export const ImageContainer = styled.div`
		flex: 1;
		position: relative;
		margin: ${({ theme }) => theme.spacings.xxlarge};
		${({ theme }) => theme.breakpoints.queries.only.mobile} {
			margin: 0;
		}
	`;
}
